import { render, staticRenderFns } from "./UserListContact.vue?vue&type=template&id=190db0a4"
import script from "./UserListContact.vue?vue&type=script&lang=js"
export * from "./UserListContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports